export const RM_PREFIX = 'RM';
export const RM_GROUP_CARD_ID = -1;
export const RM_GROUP_IMAGE = '/assets/region-metropolitana.webp';
